import React, { useCallback, useEffect } from "react";
import { TextInput, createStyles } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { debounce } from "../../utils"; // Assuming debounce function is in utils
import useDebounce from "../../utils/useDebounce";

const useStyles = createStyles((theme) => ({
  row: {
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    borderRadius: "12px",
    border: "1px solid #E5E5E5",
    background: "#FFF",

    // padding: "16px 26px",
    "@media (max-width:1300px)": {
      width: "55%",
    },
    "@media (max-width:500px)": {
      width: "95%",
    },
  },

  searchbox: {
    paddingBottom: "4px",
    width: "100%",
    borderRadius: "8px",
    color: " #737373",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "500",

    // border:"1px solid #E5E5E5",
    //  padding: "10px 14px",
  },
}));

function BillingSearchAll({
  placeholder,
  onChange,
  value,
  setValue,
  ...props
}) {
  const { classes } = useStyles();


  // const debouncedSearch = useCallback(
  //   debounce((value) => {
  //     onChange(value); 
  //   }, 2000),
  //   [onChange] 
  // );


  const debouncedSearch = useDebounce(value, 2000); 
  
  useEffect(() => {
    if (debouncedSearch) {
      onChange(value); 
    } else {
      onChange(value); 
    }
  }, [debouncedSearch]);

  // const useDebounce = (value, delay = 300) => {
  //   const [debouncedValue, setDebouncedValue] = useState(value);
  
  //   useEffect(() => {
  //     const handler = setTimeout(() => {
  //       setDebouncedValue(value);
  //     }, delay);
  
  //     return () => {
  //       clearTimeout(handler); // Cleanup timeout on every new keystroke
  //     };
  //   }, [value, delay]);
  
  //   return debouncedValue;
  // };

  const handleChange = (value) => {
    setValue(value); 
    debouncedSearch(value); 
  };

  return (
    <div>
      <div className={classes.row}>
        <TextInput
          style={{
            color: "#737373",
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: "500",
          }}
          {...props}
          // rightSection={<IconSearch size={25} />}
          icon={<IconSearch size={25} />}
          // rightSectionWidth={30}
          className={classes.searchbox}
          placeholder={placeholder}
          value={value}
          variant="unstyled"
          onChange={(e) => handleChange(e.target.value)}
        />
      </div>
    </div>
  );
}

export default BillingSearchAll;
